// extracted by mini-css-extract-plugin
export default {"contenedor":"DesasignarModal_contenedor__ysUrZ","texto":"DesasignarModal_texto__-Wxvm","aclaracion":"DesasignarModal_aclaracion__PVzAS"};